<template>
  <div class="md-layout">
    <!--User Agent : {{ userAgent }}, OS : {{ os }}-->
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="blue">
        <template slot="header">
          <div class="card-icon">
            <md-icon>group</md-icon>
          </div>
          <p class="category">Total Users</p>
          <h3 class="title">
            <span
              ><a
                href="javascript:void(0)"
                @click="$router.push({ path: '/users' })"
                :style="{ color: 'unset !important' }"
                >{{ total_users }}</a
              ></span
            >
          </h3>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="rose">
        <template slot="header">
          <div class="card-icon">
            <md-icon>payments</md-icon>
          </div>
          <p class="category">Allowed Devices</p>
          <h3 class="title">
            <span
              ><a
                href="javascript:void(0)"
                @click="$router.push({ path: '/payment-history' })"
                :style="{ color: 'unset !important' }"
                >{{ device_purchased }}</a
              ></span
            >
          </h3>
          <!--<small>+2 devices free</small>-->
        </template>

        <!--<template slot="footer">
          <div class="stats">
            <md-icon>local_offer</md-icon>
            Tracked from Google Analytics
          </div>
        </template>-->
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>tablet</md-icon>
          </div>
          <p class="category">Enrolled Devices</p>
          <h3 class="title">
            <a
              href="javascript:void(0)"
              @click="$router.push({ path: '/devices' })"
              :style="{ color: 'unset !important' }"
              >{{ total_devices }}</a
            >
          </h3>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
      <stats-card header-color="warning">
        <template slot="header">
          <div class="card-icon">
            <md-icon>content_paste</md-icon>
          </div>
          <p class="category">Total Profile</p>
          <h3 class="title">
            <span
              ><a
                href="javascript:void(0)"
                @click="$router.push({ path: '/device-profiles' })"
                :style="{ color: 'unset !important' }"
                >{{ total_profile }}</a
              ></span
            >
          </h3>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-size-50 md-small-size-100">
      <chart-card
        header-animation="false"
        :chart-data="simpleBarChart.data"
        :chart-options="simpleBarChart.options"
        :chart-responsive-options="simpleBarChart.responsiveOptions"
        chart-type="Bar"
        header-icon
        chart-inside-content
        no-footer
        background-color="green"
      >
        <template slot="chartInsideHeader">
          <div class="card-icon">
            <md-icon>insert_chart</md-icon>
          </div>
          <h4 class="title">
            Device Enrollment
            <small> - Month Wise</small>
          </h4>
        </template>
      </chart-card>
    </div>
    <div class="md-layout-item md-size-50 md-small-size-100">
      <chart-card
        header-animation="false"
        :chart-data="pieChart.data"
        :chart-options="pieChart.options"
        chart-type="Pie"
        header-icon
        chart-inside-content
        background-color="green"
      >
        <template slot="chartInsideHeader">
          <div class="card-icon">
            <md-icon>pie_chart</md-icon>
          </div>
          <h4 class="title">Device Type</h4>
        </template>
        <template slot="footer">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <h6 class="category">Legend</h6>
            </div>
            <div class="md-layout-item">
              <i class="fa fa-circle text-info"></i> Android
              <i class="fa fa-circle text-danger"></i> IOS
              <i class="fa fa-circle text-warning"></i> Chrome
            </div>
          </div>
        </template>
      </chart-card>
    </div>
    <!--<div class="md-layout-item">
      <iframe v-if="iframeMapUrl" width="100%" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" :src="iframeMapUrl"></iframe>
    </div>-->
    <div class="md-layout-item md-size-100">
      <!-- Search Card -->
      <md-card class="search-card">
        <md-card-content>
          <div class="search-row">
            <md-field class="search-field">
              <label>Search by Device Name</label>
              <md-input v-model="searchText"></md-input>
            </md-field>

            <md-button
              class="md-raised md-primary search-btn"
              :disabled="isDisabled"
              @click="getDeviceLocations()"
            >
              Search
            </md-button>
          </div>
        </md-card-content>
      </md-card>

      <!-- Map Section -->
      <div class="map-wrapper">
        <FleetMap :devicesLocation="devicesLocations" />
      </div>
    </div>
  </div>
</template>

<script>
import DashboardDataService from "../../services/DashboardDataService";
import FleetMap from "@/components/FleetMap.vue";

import {
  StatsCard,
  ChartCard,
  //ProductCard,
  AnimatedNumber,
  //GlobalSalesCard,
  //GlobalSalesTable,
} from "@/components";

export default {
  components: {
    StatsCard,
    ChartCard,
    FleetMap,
    //AnimatedNumber,
    //ProductCard,
    //GlobalSalesCard,
    //GlobalSalesTable,
    //AsyncWorldMap,
  },
  data() {
    return {
      isDisabled: false,
      total_users: 0,
      total_devices: 0,
      device_purchased: 0,
      total_applications: 0,
      total_profile: 0,
      pie_chart_data: [],
      simpleBarChart: null,
      pieChart: null,

      os: "",
      userAgent: "",
      iframeMapUrl: "",
      devicesLocations: [],
      searchText: "",
    };
  },
  methods: {
    GetDashboardData: function () {
      DashboardDataService.GetDashboardData()
        .then((response) => {
          this.total_users = response.data.data.application_user_count;
          this.total_devices = response.data.data.device_count;
          this.total_applications = response.data.data.application_count;
          this.total_profile = response.data.data.profile_count;

          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    },
    getDeviceLocations() {
      this.isDisabled = true;
      let data = {
        label: this.searchText,
      };
      DashboardDataService.getDeviceLocations(data)
        .then((response) => {
          this.isDisabled = false;
          this.devicesLocations = [...response.data.data];
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
          this.isDisabled = false;
        });
    },
    CreateNextCloudUser: function () {
      DashboardDataService.CreateNextCloudUser()
        .then((response) => {
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    calculateBoundingBox(latStr, longStr, zoomOutFactor) {
      const latitude = parseFloat(latStr);
      const longitude = parseFloat(longStr);

      // Check if the conversion was successful (NaN check)
      if (isNaN(latitude) || isNaN(longitude)) {
        return null;
      }

      // Calculate the bounding box by subtracting/adding the zoomOutFactor to the center point coordinates
      const west = longitude - zoomOutFactor;
      const east = longitude + zoomOutFactor;
      const south = latitude - zoomOutFactor;
      const north = latitude + zoomOutFactor;

      // Return the bounding box as an object
      return {
        west: west,
        south: south,
        east: east,
        north: north,
      };
    },
  },
  mounted() {
    this.userAgent = navigator.userAgent;
    this.os = navigator.platform;
    //this.GetDashboardData();
  },
  beforeMount() {
    this.getDeviceLocations();
  },
  async created() {
    await DashboardDataService.GetDashboardData()
      .then((response) => {
        this.total_users = response.data.data.application_user_count;
        this.device_purchased = response.data.data.device_purchased;
        this.total_devices = response.data.data.device_count;
        this.total_applications = response.data.data.application_count;
        this.total_profile = response.data.data.profile_count;
        /*if (response?.data?.data?.devicesLocation.length > 0) {
            const encodedMarkers = encodeURIComponent(JSON.stringify(response?.data?.data?.devicesLocation));
            this.iframeMapUrl = `/multiMarker.html?zoom=4&markers=${encodedMarkers}`;
          }*/
        this.pieChart = {
          data: {
            labels: [
              response.data.data.androidDeviceCount,
              response.data.data.iosDeviceCount,
              response.data.data.chromeDeviceCount,
            ],
            series: [
              response.data.data.androidDeviceCount,
              response.data.data.iosDeviceCount,
              response.data.data.chromeDeviceCount,
            ],
          },
          options: {
            height: "230px",
          },
        };

        this.simpleBarChart = {
          data: {
            labels: [
              "Jan",
              "Feb",
              "March",
              "Apr",
              "May",
              "June",
              "July",
              "Aug",
              "Sept",
              "Oct",
              "Nov",
              "Dec",
            ],
            series: [response.data.data.month_wise_device_count],
          },
          options: {
            height: "230px",
            seriesBarDistance: 10,
            axisX: {
              showGrid: false,
            },
          },
          responsiveOptions: [
            [
              "screen and (max-width: 640px)",
              {
                seriesBarDistance: 5,
                axisX: {
                  labelInterpolationFnc: function (value) {
                    return value[0];
                  },
                },
              },
            ],
          ],
        };

        if (response.data.data.next_cloud_account_created == false) {
          this.CreateNextCloudUser();
        }
      })
      .catch((e) => {
        if (e.response) {
          if (e.response.data.is_logout == 1) {
            localStorage.setItem("token", "");
            this.$router.push("login");
          }
          this.$toast.error(e.response.data.respones_msg);
        }
      });
  },
};
</script>
<style scoped>
.md-card-chart {
  height: 370px !important;
  margin: unset !important;
}
audio:not(.md-image),
canvas:not(.md-image),
embed:not(.md-image),
iframe:not(.md-image),
img:not(.md-image),
object:not(.md-image),
video:not(.md-image) {
  height: revert-layer !important;
}
.search-card {
  margin-bottom: 8px;
  padding: 0;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-field {
  flex: 1;
}

.search-btn {
  height: 40px;
  margin-top: 10px;
}

.reset-btn {
  height: 40px;
  margin-top: 10px;
  background: #e0e0e0;
}

.map-wrapper {
  margin-top: -60px;
  border-radius: 6px;
  overflow: hidden;
}
</style>
